import React from 'react';
import ContactForm from '../molecules/ContactForm';

const ContactModal = ({
  isOpen,
  onClose,
  title = 'お問い合わせ',
  serviceName = '',
  formData,
  onFormChange,
  onSubmit
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-4 md:p-6 border-b">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-xl md:text-2xl font-bold">{title}</h3>
              {serviceName && (
                <span className="inline-block bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-xs md:text-sm mt-2">
                  {serviceName}
                </span>
              )}
            </div>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-xl md:text-2xl transition-colors"
            >
              ×
            </button>
          </div>
        </div>
        <div className="p-4 md:p-6">
          <ContactForm
            formData={formData}
            onChange={onFormChange}
            onSubmit={onSubmit}
            serviceName={serviceName}
          />
        </div>
        <div className="p-4 md:p-6 border-t flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 md:px-6 py-2 text-gray-600 hover:text-gray-800 transition-colors text-sm md:text-base"
          >
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
